<template>
  <div :class="classes">
    <b-form-input disabled v-if="disabled" :placeholder="placeholder" />
    <flat-pickr
      v-model="local_value"
      :config="config"
      :placeholder="placeholder"
      v-else
    />

    <div
      class="clear-value"
      :class="{ 'has-value': has_value }"
      @click="clearValue"
    >
      <font-awesome-icon icon="fas fa-times-circle" />
    </div>
  </div>
</template>

<script>
import {
  formControlMixin,
  props as formControlProps,
} from "bootstrap-vue/src/mixins/form-control";

import {
  formStateMixin,
  props as formStateProps,
} from "bootstrap-vue/src/mixins/form-state";

import { sortKeys } from "bootstrap-vue/src/utils/object";
import { makePropsConfigurable } from "bootstrap-vue/src/utils/props";

import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import { Portuguese } from "flatpickr/dist/l10n/pt.js";

const props = makePropsConfigurable(
  sortKeys({
    ...formStateProps,
    ...formControlProps,
    value: "",
    return_object: false,
    placeholder: {
      type: String,
      default: "Selecione uma data",
    },
    size: {
      type: String,
      default: "md",
    },
    dateConfig: {
      type: Object,
      default: () => ({}),
    },
  })
);

export default {
  components: { flatPickr },
  mixins: [formControlMixin, formStateMixin],
  props,
  data: () => ({}),
  computed: {
    local_value: {
      set(value) {
        this.$emit("input", value);
      },
      get() {
        return this.value;
      },
    },
    has_value() {
      return this.value ? true : false;
    },
    config() {
      return {
        wrap: true,
        altFormat: "d/m/Y",
        altInput: true,
        allowInput: true,
        dateFormat: "Y-m-d",
        locale: Portuguese,
        ...this.dateConfig,
      };
    },
    classes() {
      let classes = ["form-control", "datepicker"];
      if (this.stateClass) {
        classes.push(this.stateClass);
      }
      return classes;
    },
  },
  methods: {
    clearValue() {
      this.local_value = null;
    },
  },
  watch: {},
  async created() {},
};
</script>

<style lang="scss">
.form-control.datepicker {
  position: relative;
  padding: 0 !important;

  .form-control {
    border: none;
    height: calc(1.5em + 1.25rem);
  }

  .clear-value {
    position: absolute;
    top: 0.625rem;
    right: 0.75rem;
    cursor: pointer;
    opacity: 0;
    transition: all 0.3s;

    &.has-value {
      opacity: 1;
    }
  }
}
</style>
